<template>
  <l-map
    :zoom.sync="zoom"
    :center="center"
    style="height: 500px; width: 100%"
    ref="mapaUnidadeDeSaude"
    :options="{ zoomControl: false }"
  >
    <l-tile-layer :url="url" :attribution="attribution" />
    <l-control-zoom position="bottomright"></l-control-zoom>

    <!-- Botão no canto superior direito -->
    <l-control position="topright">
      <button
        class="leaflet-bar expand-btn"
        @click="$bvModal.show('modal-mapa-full')"
        title="Expandir"
      >
        <i class="icofont-expand"></i>
      </button>
    </l-control>

    <!-- <template v-for="item in dadosDoMapa">
          <div :key="item.key">
            <l-circle-marker
              :lat-lng="[item?.latitude, item?.longitude]"
              :radius="getRadiusMarker(item)"
              :color="getRadiusColor(item)"
              :fillColor="getRadiusColor(item)"
              :stroke="false"
              :fillOpacity="0.6"
            >
              <l-tooltip
                :options="{
                  permanent: true,
                  direction: 'center',
                  className: 'map-radius',
                  interactive: true,
                }"
              >
                {{ item?.denominador }}
              </l-tooltip>
              <l-popup>
                <div class="tooltip-latlgn">
                  <span> UBS: {{ item?.no_ubs }}</span>
                  <br />
                  <span>
                    CNES + INE: {{ item?.cnes }} | {{ item?.ine }} |
                    {{ item?.tipo_equipe }}</span
                  >
                  <br />
                  <span> PARÂMETRO: {{ item?.min_cad }} pessoas </span>
                  <br />
                  <span>
                    CADASTROS e-SUS: {{ item?.denominador }} pessoas
                  </span>
                  <br />
                  <span> MÁXIMO: {{ item?.max_cad }} pessoas </span>
                  <br />
                  <div class="mt-2">
                    <span
                      ><strong>ATENÇÃO!</strong>
                      <br />
                      {{ item.recomendacao_cadastro }}</span
                    >
                  </div>
                </div>
              </l-popup>
            </l-circle-marker>
          </div>
        </template> -->

    <!-- Modal fullscreen com outro mapa -->
    <b-modal
      id="modal-mapa-full"
      hide-header
      hide-footer
      modal-class="bv-modal-fullscreen"
      body-class="p-0"
      :no-close-on-esc="false"
      :no-close-on-backdrop="false"
      @shown="onModalShown"
    >
      <!-- Topbar do modal -->
      <div class="modal-topbar">
        <!-- <div class="title">Mapa em tela cheia</div> -->
        <button
          class="leaflet-bar expand-btn"
          @click="$bvModal.hide('modal-mapa-full')"
          title="Fechar"
        >
          <i class="icofont-close"></i>
        </button>
      </div>

      <l-map
        :zoom.sync="zoomFull"
        :center="centerFull"
        style="height: 100vh; width: 100%"
        ref="mapaUnidadeDeSaudeFull"
        :options="{ zoomControl: false }"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-control-zoom position="bottomright"></l-control-zoom>
      </l-map>
    </b-modal>
  </l-map>
</template>

<script>
import * as Functions from './functions.js'
import { coordinates } from '@/pages/PrevineBrasil/coordinates'
import mapa from '@/pages/PrevineBrasil/arquivos/mapa_ranking_regional'
import {
  LMap,
  LCircle,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
  LPopup,
  LControl,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet.markercluster/dist/leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

export default {
  components: {
    LMap,
    LCircle,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    LPopup,
    LControl,
    LMarkerCluster: L.markerClusterGroup,
  },
  props: {
    dadosResultado: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      zoom: 10,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      dadosDoMapa: [],
      zoomFull: 10,
      centerFull: latLng(-15.2, -51.31),
    }
  },
  methods: {
    initMap() {
      this.dadosDoMapa = this.dadosResultado.filter((item) => {
        return item.latitude !== null
      })
      setTimeout(() => {
        const cod_ibge = this.$store.state.cod_ibge
        const state = this.$store.state.cidade.split('-')[1].trim()

        // pega as coordenadas do municipio
        const countyCoordinates = mapa.find((item) => {
          return item.co_ibge === cod_ibge
        })

        // pega o zoom para o estado
        const coordinatesState = coordinates.find((item) => {
          return item.uf === state
        })
        const mapObject = this.$refs.mapaUnidadeDeSaude.mapObject

        mapObject.invalidateSize(true)
        mapObject.setView(
          latLng(countyCoordinates.local[0], countyCoordinates.local[1]),
          coordinatesState.zoom + 4
        )

        this.addMarkers()
      }, 500)
    },

    addMarkers() {
      const markerCluster = L.markerClusterGroup()
      const mapObject = this.$refs.mapaUnidadeDeSaude.mapObject
      const markersData = this.dadosDoMapa

      markersData.forEach((data) => {
        if (data.latitude && data.longitude) {
          // const marker = L.marker([data.latitude, data.longitude])
          let marker = L.circleMarker([data.latitude, data.longitude], {
            radius: Functions.getRadius(data),
            color: Functions.getRadiusColor(data),
            fillColor: Functions.getRadiusColor(data),
            stroke: false,
            fillOpacity: 0.6,
          })

          let popupContent = `
            <div class="tooltip-latlgn">
              <span>UBS: ${data.no_ubs}</span><br />
              <span>CNES + INE: ${data.cnes} | ${data.ine} | ${data.tipo_equipe}</span><br />
              <span>PARÂMETRO: ${data.min_cad} pessoas</span><br />
              <span>CADASTROS e-SUS: ${data.cadastros_esus} pessoas</span><br />
              <span>MÁXIMO: ${data.max_cad} pessoas</span><br />
              <div class="mt-2">
                <span><strong>ATENÇÃO!</strong><br />${data.recomendacao_cadastro}</span>
              </div>
            </div>
          `

          // Adicionar tooltip permanente com as opções fornecidas
          marker
            .bindTooltip(`${data.cadastros_esus}`, {
              permanent: true,
              direction: 'center',
              className: 'map-radius',
              interactive: true,
            })
            .openTooltip()

          // Adicionar evento de mouseover para mostrar o popup
          marker.on('mouseover', function () {
            marker.bindPopup(popupContent).openPopup()
          })

          // Adicionar evento de mouseout para fechar o popup
          marker.on('mouseout', function () {
            marker.closePopup()
          })

          markerCluster.addLayer(marker)
        }
      })

      mapObject.addLayer(markerCluster)
    },

    getRadiusMarker(item) {
      return Functions.getRadius(item)
    },

    getRadiusColor(item) {
      return Functions.getRadiusColor(item)
    },

    onModalShown() {
      // Sincroniza centro/zoom do mapa principal
      const mapInline = this.$refs.mapaUnidadeDeSaude?.mapObject
      if (mapInline) {
        this.centerFull = mapInline.getCenter()
        this.zoomFull = mapInline.getZoom()
      }

      this.$nextTick(() => {
        const mapFull = this.$refs.mapaUnidadeDeSaudeFull?.mapObject
        if (!mapFull) return

        // Ajusta tamanho ao abrir o modal
        mapFull.invalidateSize(true)

        // Limpa camadas não-tile ao reabrir
        mapFull.eachLayer((layer) => {
          if (layer && typeof layer.getAttribution !== 'function') {
            mapFull.removeLayer(layer)
          }
        })

        // Adiciona marcadores no mapa do modal
        this.addMarkersToFull(mapFull)
      })
    },

    addMarkersToFull(mapObject) {
      // Reaproveita seus dados já filtrados
      const markersData = this.dadosDoMapa
      const markerCluster = L.markerClusterGroup()

      markersData.forEach((data) => {
        if (data.latitude && data.longitude) {
          const marker = L.circleMarker([data.latitude, data.longitude], {
            radius: Functions.getRadius(data),
            color: Functions.getRadiusColor(data),
            fillColor: Functions.getRadiusColor(data),
            stroke: false,
            fillOpacity: 0.6,
          })

          const popupContent = `
        <div class="tooltip-latlgn">
          <span>UBS: ${data.no_ubs}</span><br />
          <span>CNES + INE: ${data.cnes} | ${data.ine} | ${data.tipo_equipe}</span><br />
          <span>PARÂMETRO: ${data.min_cad} pessoas</span><br />
          <span>CADASTROS e-SUS: ${data.cadastros_esus} pessoas</span><br />
          <span>MÁXIMO: ${data.max_cad} pessoas</span><br />
          <div class="mt-2">
            <span><strong>ATENÇÃO!</strong><br />${data.recomendacao_cadastro}</span>
          </div>
        </div>
      `

          marker
            .bindTooltip(`${data.cadastros_esus}`, {
              permanent: true,
              direction: 'center',
              className: 'map-radius',
              interactive: true,
            })
            .openTooltip()

          marker.on('mouseover', function () {
            marker.bindPopup(popupContent).openPopup()
          })
          marker.on('mouseout', function () {
            marker.closePopup()
          })

          markerCluster.addLayer(marker)
        }
      })

      mapObject.addLayer(markerCluster)
    },
  },
}
</script>

<style lang="scss">
.expand-btn {
  display: inline-block;
  padding: 5px;
  line-height: 26px;
  font-size: 22px;
  cursor: pointer;
  border: 1px solid #ccc;
  background: #fff;
}

.bv-modal-fullscreen {
  .modal-dialog {
    max-width: 100%;
    margin: 0;
    height: 100vh;
  }

  .modal-content {
    height: 100vh;
    border: 0;
    border-radius: 0;
  }

  .modal-body {
    padding: 0;
    height: 100%;
  }
}

.modal-topbar {
  position: absolute;
  z-index: 1000;
  top: 12px;
  right: 12px;
  left: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  pointer-events: none;

  .title {
    pointer-events: auto;
    background: rgba(255, 255, 255, 0.9);
    padding: 4px 10px;
    border-radius: 6px;
    font-weight: 600;
  }

  .expand-btn {
    pointer-events: auto;
  }
}
</style>
